import styled from "styled-components";

const SelectAddonComponent = styled.div`
  display: inline-flex;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
`

const AddonComponent = styled.div`
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E9ECEF;
  color: #495057;
  border-right: 1px solid rgba(0, 0, 0, 0.125);
`

const SelectContainerComponent = styled.div`
  width: calc(100% - 42px);
  & div {
    border-color: transparent;
    border-radius: 0;
    border-style: none;
  }
`

export default SelectAddonComponent;

export {
  AddonComponent,
  SelectContainerComponent
};
